import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=3694a9ae&"
import script from "./cookie-banner.vue?vue&type=script&lang=js&"
export * from "./cookie-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports